import { useMutation } from '@tanstack/react-query';

import { post } from '../api/requester';
import type { Promotion, PromotionCodeCheckParams } from '../types/commons';

const promotions = {
  check: async (code: PromotionCodeCheckParams) => post('/promotions/check', { body: code }),
};

export const useCheckPromotions = () =>
  useMutation<Promotion, Error, PromotionCodeCheckParams>({
    mutationKey: ['promotions', 'check'],
    mutationFn: (params: PromotionCodeCheckParams) => promotions.check(params),
  });
